import React from 'react';
import { createRoot } from 'react-dom/client';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import UpcomingEventsList from '../../src/events_index/components/upcoming_events_list/upcoming_events_list';
import PastEventsList from '../../src/events_index/components/past_events_list/past_events_list';

const renderUpcomingEvents = () => {
  const upcomingEventsContainer = document.getElementById('upcoming-events-react');
  if (!upcomingEventsContainer) return null;

  const upcomingEventsRoot = createRoot(upcomingEventsContainer);
  upcomingEventsRoot.render(
    <DevexHighOrderComponent>
      <UpcomingEventsList showAllEventsLogic={true} numberOfEventsOnMount={3} />
    </DevexHighOrderComponent>
  );
};

const renderPastEvents = () => {
  const pastEventsContainer = document.getElementById('past-events-react');
  if (!pastEventsContainer) return null;

  const pastEventsRoot = createRoot(pastEventsContainer);
  pastEventsRoot.render(
    <DevexHighOrderComponent>
      <PastEventsList showMoreEventsLogic={true} />
    </DevexHighOrderComponent>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  renderUpcomingEvents();
  renderPastEvents();
});
